export const QUOTE_EXPIRATION_OPTIONS = [
  { value: 'SAME_DAY', label: 'Same Day' },
  { value: 'HOURS_24', label: '24 Hours' },
  { value: 'HOURS_48', label: '48 Hours' },
  { value: 'HOURS_72', label: '72 Hours' },
];

export const SUCCESSIVE_LEASE_TERM_MAP = {
  monthly: 'monthToMonth',
  annual: 'annual',
};

export const SUCCESSIVE_LEASE_TERM_OPTIONS = [
  { value: 'monthly', label: 'monthToMonth' },
  { value: 'annual', label: 'annual' },
];

export const HOUSING_ASSISTANCE_VOUCHER_OPTIONS = [
  { value: 'true', label: 'Yes - Accepts Housing Assistance' },
  { value: 'false', label: 'No - Does Not Accept Housing Assistance' },
];

export const AGED_UP_MINOR_TYPE_ID = 'a0551f77-cb33-4693-876c-b2e637bbc375';

export const FINANCIAL_LEASE_SIGNER_TYPE_ID =
  'b05dbb6f-4239-4a01-8de7-96857781ee4f';

export const NON_FINANCIAL_LEASE_SIGNER_TYPE_ID =
  '6e0d60d5-b0b1-40d1-83dc-5a6339b4aae5';

export const MTM_RENT_SOURCE = {
  LEASE_RENT: 'LEASE_RENT',
  CURRENT_QUOTING_RENT: 'CURRENT_QUOTING_RENT',
};
